import { gql } from '../../../apollo/__generated__';

export const UPDATE_ORGA_COMMENT = gql(`
  mutation UpdateOrgaComment($updateOrgaCommentInput: UpdateOrgaCommentInput!, $eventId: ID!) {
    updateOrgaComment(updateOrgaCommentInput: $updateOrgaCommentInput) {
      id
      orgaComment(eventId: $eventId)
    }
  }
`);
